import { Identifiable, ProjectResource, Resource } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByGroups(
  { uuid }: Identifiable<Resource>,
  { groups }: Filter,
): boolean {
  return (
    !!groups &&
    groups.length > 0 &&
    !groups
      .reduce<
        (Identifiable<Resource> | Identifiable<ProjectResource>)[]
      >((acc, { resources }) => [...acc, ...resources], [])
      .find(
        (resource) =>
          ("resource" in resource ? resource.resource.uuid : resource.uuid) ===
          uuid,
      )
  );
}

export { isFilteredByGroups };
